var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEditIconPencil = function SvgEditIconPencil(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "edit icon copy 2")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Mockups---Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Change-organization-name",
    transform: "translate(-1099.000000, -611.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit-icon-copy-2",
    transform: "translate(1100.000000, 612.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "icon-copy",
    stroke: "#165E96",
    fill: "none",
    style: {
      mixBlendMode: "multiply"
    },
    cx: 16,
    cy: 16,
    r: 16
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(9.000000, 10.000000)",
    fill: "#165E96"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Combined-Shape",
    points: "1.83546667 9.01935251 4.07813333 11.6702858 9.1504 7.38868584 10.2461333 6.44548584 13.1018667 4.04948584 10.8592 1.39828584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6053333,1.65321917 L13.4584,0.302285841 C13.1773333,-0.0539808257 12.6434667,-0.104914159 12.2856,0.200685841 L11.2912,1.04175251 L13.5357333,3.69241917 L14.5034667,2.85161917 C14.86,2.54575251 14.9106667,2.01055251 14.6053333,1.65321917",
    id: "Fill-210"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-212",
    points: "-6.06329801e-14 12.8681525 3.49146667 12.0268192 1.4016 9.52948584 -6.06329801e-14 12.8681525"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEditIconPencil, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit-icon-pencil.f9b1b8bc.svg";
export { ForwardRef as ReactComponent };